import {
  ExtendedTypography,
  GridEmptyState,
} from '@issuemanager/apps/client/components';
import { paths } from '@issuemanager/apps/client/paths';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink } from '@mui/material';
import { Stack } from '@mui/system';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function IssueTemplatesEmptyState() {
  const { t } = useTranslation(['common', 'settings']);
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <GridEmptyState>
      <Stack spacing={1.5} alignItems='center'>
        <ExtendedTypography fontWeight='medium'>
          {t('common:table.empty')}
        </ExtendedTypography>
        <ExtendedTypography
          variant='body2'
          color={semantic.color.text.muted.value}
        >
          <Trans
            t={t}
            i18nKey='settings:issueTemplates.table.notFoundMessage'
            components={{
              externalLink: (
                <MUILink
                  data-testid='add-issue-template-link-button'
                  style={{ pointerEvents: 'auto' }}
                  component={Link}
                  to={paths.issueTemplates.add}
                />
              ),
            }}
          />
        </ExtendedTypography>
      </Stack>
    </GridEmptyState>
  );
}
